// src/components/Registros/forms/DotacionForm.jsx
import React, { useState } from 'react';
import { Container, Form, Button, Row, Col, Alert, Table } from 'react-bootstrap';
import { FaArrowLeft, FaSave, FaTimes, FaPlus, FaTrash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import SelectMult from '../../SettingNot/SelectMult';
import { useNavigate } from 'react-router-dom';
import AdjuntosRegistro from '../AdjuntosRegistro';
import { crearDatos } from '../../../api/common';

const DotacionForm = ({ onClose, onSubmit, tipoRegistro, solicitante }) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    solicitante: solicitante,
    titulo: '',
    fechaInicio: '',
    fechaFin: '',
    descripcion: '',
    elementosDotacion: [{ tipo: '', talla: '', cantidad: 1, descripcion: '' }],
    responsablesAprobacion: [],
    adjuntos: []
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const responsables = [
    { id: '1', nombre: 'Juan Pérez', cargo: 'Jefe de RRHH' },
    { id: '2', nombre: 'María García', cargo: 'Coordinador de Seguridad' }
  ];

  const tiposDotacion = [
    'Uniforme',
    'Calzado de seguridad',
    'Casco',
    'Gafas de protección',
    'Guantes',
    'Chaleco reflectivo',
    'Tapabocas',
    'Protector auditivo',
    'Overol',
    'Delantal',
    'Botas',
    'Otro'
  ];

  const tallas = ['XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL', '36', '37', '38', '39', '40', '41', '42', '43', '44', 'Única'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleElementoChange = (index, field, value) => {
    const newElementos = [...formData.elementosDotacion];
    newElementos[index][field] = value;
    setFormData(prev => ({
      ...prev,
      elementosDotacion: newElementos
    }));
  };

  const agregarElemento = () => {
    setFormData(prev => ({
      ...prev,
      elementosDotacion: [...prev.elementosDotacion, { tipo: '', talla: '', cantidad: 1, descripcion: '' }]
    }));
  };

  const eliminarElemento = (index) => {
    if (formData.elementosDotacion.length === 1) {
      Swal.fire({
        icon: 'warning',
        title: 'Atención',
        text: 'Debe haber al menos un elemento en la solicitud',
        confirmButtonColor: '#0d6efd'
      });
      return;
    }

    setFormData(prev => ({
      ...prev,
      elementosDotacion: prev.elementosDotacion.filter((_, i) => i !== index)
    }));
  };

    const handleResponsableChange = (e) => {
    const { value } = e.target; // value es un array de IDs: ['id1', 'id2', ...]
    
    // Transformar el array de IDs a objetos con la estructura del modelo
    const responsablesFormateados = value?.map((usuarioId, index) => ({
      usuario: usuarioId,
      orden: index + 1,
      estado: 'pendiente'
    }));
    setFormData(prev => ({
      ...prev,
      responsablesAprobacion: responsablesFormateados
    }));
  };

  const validateForm = () => {
    const newErrors = {};

    // Título se autogenera (ver handleSubmit).

    if (!formData.fechaInicio) {
      newErrors.fechaInicio = 'La fecha de inicio es requerida';
    }

    if (!formData.fechaFin) {
      newErrors.fechaFin = 'La fecha de fin es requerida';
    }

    if (formData.fechaInicio && formData.fechaFin) {
      if (new Date(formData.fechaFin) < new Date(formData.fechaInicio)) {
        newErrors.fechaFin = 'La fecha fin debe ser mayor o igual a la fecha inicio';
      }
    }

    const elementosValidos = formData.elementosDotacion.every(elemento => 
      elemento.tipo && elemento.talla && elemento.cantidad > 0
    );

    if (!elementosValidos) {
      newErrors.elementosDotacion = 'Todos los elementos deben tener tipo, talla y cantidad';
    }

    if (formData.responsablesAprobacion.length === 0) {
      newErrors.responsablesAprobacion = 'Debe seleccionar al menos un responsable';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      Swal.fire({
        icon: 'error',
        title: 'Errores en el formulario',
        text: 'Por favor, corrija los errores antes de continuar',
        confirmButtonColor: '#0d6efd'
      });
      return;
    }

    setLoading(true);

    try {
      const dataToSubmit = {
        ...formData,
        titulo: 'Solicitud de dotación',
        tipoSolicitud: 'dotacion',
        causaInactividad: false
      };

      await crearDatos('Registro', dataToSubmit);

      await Swal.fire({
        icon: 'success',
        title: 'Solicitud Enviada',
        text: 'Tu solicitud de dotación ha sido registrada correctamente',
        confirmButtonColor: '#198754'
      });
      if (onSubmit) onSubmit(dataToSubmit);
      navigate('/Solicitudes');
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un error al enviar la solicitud. Por favor, intenta nuevamente.',
        confirmButtonColor: '#dc3545'
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Los datos ingresados se perderán',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No, continuar'
    }).then((result) => {
      if (result.isConfirmed) {
        onClose();
      }
    });
  };

  return (
    <Container fluid className="py-4" style={{ background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', minHeight: '100vh' }}>
      <div className="form-container">
        <div className="form-header" style={{ background: 'linear-gradient(135deg, #6610f2 0%, #520dc2 100%)' }}>
          <div className="d-flex align-items-center">
            <Button variant="light" size="sm" onClick={handleCancel} className="me-3">
              <FaArrowLeft />
            </Button>
            <div>
              <h3 className="mb-0 fw-bold">Solicitud de Dotación</h3>
              <p className="mb-0 opacity-75">Complete el formulario para solicitar elementos de dotación</p>
            </div>
          </div>
        </div>

        <div className="form-body">
          <Form onSubmit={handleSubmit}>
            {/* Información Básica */}
            <div className="form-section">
              <h5 className="form-section-title">Información Básica</h5>
              
              <Row className="mb-3">
                <Col md={12}>
                  <Form.Group>
                    <Form.Label className="fw-bold" style={{display:'none'}}>Título (auto)</Form.Label>
                    <Form.Control
                      type="hidden"
                      name="titulo"
                      value={formData.titulo}
                      onChange={handleChange}
                      placeholder="Ej: Dotación de uniformes para personal operativo"
                      isInvalid={!!errors.titulo}
                      maxLength={100}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.titulo}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Fecha Requerida (Inicio) *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaInicio"
                      value={formData.fechaInicio}
                      onChange={handleChange}
                      isInvalid={!!errors.fechaInicio}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fechaInicio}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label className="fw-bold">Fecha Límite (Fin) *</Form.Label>
                    <Form.Control
                      type="date"
                      name="fechaFin"
                      value={formData.fechaFin}
                      onChange={handleChange}
                      isInvalid={!!errors.fechaFin}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.fechaFin}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
              </Row>
            </div>

            {/* Elementos de Dotación */}
            <div className="form-section">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h5 className="form-section-title mb-0">Elementos de Dotación</h5>
                <Button 
                  variant="primary" 
                  size="sm"
                  onClick={agregarElemento}
                >
                  <FaPlus className="me-2" />
                  Agregar Elemento
                </Button>
              </div>

              {errors.elementosDotacion && (
                <Alert variant="danger" className="mb-3">
                  {errors.elementosDotacion}
                </Alert>
              )}

              <div className="table-responsive">
                <Table bordered hover>
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: '25%' }}>Tipo de Elemento *</th>
                      <th style={{ width: '15%' }}>Talla *</th>
                      <th style={{ width: '15%' }}>Cantidad *</th>
                      <th style={{ width: '35%' }}>Descripción/Especificaciones</th>
                      <th style={{ width: '10%' }}>Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    {formData.elementosDotacion.map((elemento, index) => (
                      <tr key={index}>
                        <td>
                          <Form.Select
                            value={elemento.tipo}
                            onChange={(e) => handleElementoChange(index, 'tipo', e.target.value)}
                            size="sm"
                          >
                            <option value="">Seleccione</option>
                            {tiposDotacion.map(tipo => (
                              <option key={tipo} value={tipo}>{tipo}</option>
                            ))}
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Select
                            value={elemento.talla}
                            onChange={(e) => handleElementoChange(index, 'talla', e.target.value)}
                            size="sm"
                          >
                            <option value="">Talla</option>
                            {tallas.map(talla => (
                              <option key={talla} value={talla}>{talla}</option>
                            ))}
                          </Form.Select>
                        </td>
                        <td>
                          <Form.Control
                            type="number"
                            value={elemento.cantidad}
                            onChange={(e) => handleElementoChange(index, 'cantidad', e.target.value)}
                            min="1"
                            size="sm"
                          />
                        </td>
                        <td>
                          <Form.Control
                            type="text"
                            value={elemento.descripcion}
                            onChange={(e) => handleElementoChange(index, 'descripcion', e.target.value)}
                            placeholder="Color, marca, etc."
                            size="sm"
                          />
                        </td>
                        <td className="text-center">
                          <Button
                            variant="danger"
                            size="sm"
                            onClick={() => eliminarElemento(index)}
                            disabled={formData.elementosDotacion.length === 1}
                          >
                            <FaTrash />
                          </Button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>

            {/* Descripción */}
            <div className="form-section">
              <h5 className="form-section-title">Justificación</h5>
              
              <Form.Group className="mb-3">
                <Form.Label className="fw-bold">Descripción</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={4}
                  name="descripcion"
                  value={formData.descripcion}
                  onChange={handleChange}
                  placeholder="Describa el motivo de la solicitud de dotación..."
                  maxLength={500}
                />
                <Form.Text className="text-muted">
                  {formData.descripcion.length}/500 caracteres
                </Form.Text>
              </Form.Group>
            </div>

            {/* Responsables */}
            <div className="form-section">
              <h5 className="form-section-title">Responsables de Aprobación</h5>
              
              <Form.Group>
                <Form.Label className="fw-bold">Seleccione los responsables que deben aprobar *</Form.Label>
                <SelectMult
                //dataDefault={itemData?.userAutorizados}
                handledata={handleResponsableChange}
                name='responsablesAprobacion'
                collection={"Usuarios"}
                field={"nombre"}
                baseFilter={[ // Body para la consuta aggregate de mongo para metrologos y que esten activos.
                        {
                            "$match": {
                            'status': 'activo'
                            } 
                        },
                        {
                            "$lookup": {
                            "from": "roles",
                            "localField": "role",
                            "foreignField": "_id",
                            "as": "result"
                            }
                        },
                        {
                            "$match": {
                            "result.nombre": { $ne: "Cliente" } 
                            }
                        }
                        ]}
                />
                {errors.responsablesAprobacion && (
                  <Alert variant="danger" className="mt-2 py-2">
                    {errors.responsablesAprobacion}
                  </Alert>
                )}
              </Form.Group>
            </div>

            <div className="form-section">
              <h5 className="form-section-title">Adjuntos</h5>
              <AdjuntosRegistro
                tipoSolicitud="dotacion"
                adjuntos={formData.adjuntos}
                onChange={(arr) => setFormData(prev => ({ ...prev, adjuntos: arr }))}
                disabled={loading}
              />
            </div>

            {/* Botones */}
            <div className="d-flex justify-content-end gap-2 mt-4">
              <Button 
                variant="secondary" 
                onClick={handleCancel}
                disabled={loading}
                className="px-4"
              >
                <FaTimes className="me-2" />
                Cancelar
              </Button>
              <Button 
                variant="primary" 
                type="submit"
                disabled={loading}
                className="px-4"
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Enviando...
                  </>
                ) : (
                  <>
                    <FaSave className="me-2" />
                    Enviar Solicitud
                  </>
                )}
              </Button>
            </div>
          </Form>
        </div>
      </div>
    </Container>
  );
};

export default DotacionForm;